var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.447 17.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_down",
    "data-name": "Arrow down",
    transform: "translate(0 17.184) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-_-Desktop-_-default",
    "data-name": "Header-/-Desktop-/-default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-_-Navi",
    "data-name": "Logo-+-Navi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Services"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-758",
    d: "M15.594.48,17.535,2.4,8.943,10.926.351,2.4,2.291.48l6.652,6.6Z",
    transform: "translate(-0.351 -0.48)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow_right_white.8e34a439bc0d11ec6280c37e6c7f68bb.svg";
export { ForwardRef as ReactComponent };